// Mock data for Owen Dilley's retro TV portfolio
// Replace these with real uploads via admin panel later

export const SAMPLE_VIDEOS = {
  bunny: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  elephant: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  blazes: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  escapes: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  fun: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  joyrides: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4'
};

export const ANIMATION_WORKS = [
  {
    id: 'anim-01',
    title: 'Channel Drift',
    date: '2024-11-03',
    runtime: '00:42',
    description: 'A looped character study exploring the feeling of drifting between television channels at 3 AM. Hand-keyed on twos with a grainy film overlay.',
    poster: 'https://images.unsplash.com/photo-1714972255728-7796cf11bb24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwYW5pbWF0aW9ufGVufDB8fHxvcmFuZ2V8MTc3Nzg2OTIyNnww&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.bunny
  },
  {
    id: 'anim-02',
    title: 'Static Garden',
    date: '2024-08-17',
    runtime: '01:10',
    description: 'Procedural motion piece combining flocking simulations with rotoscoped botanical forms. Built in Houdini, composited in After Effects.',
    poster: 'https://images.unsplash.com/photo-1618599919511-c0cd9e3625cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxmaWxtJTIwZnJhbWV8ZW58MHx8fHwxNzc3ODY5MjQyfDA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.elephant
  },
  {
    id: 'anim-03',
    title: 'Late Transmission',
    date: '2024-03-22',
    runtime: '00:58',
    description: 'Short narrative loop of a broadcast tower losing signal across decades. Mixed 2D and 3D, toon-shaded, grain plates from 8mm archive footage.',
    poster: 'https://images.unsplash.com/photo-1658580768843-510733773b12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwYW5pbWF0aW9ufGVufDB8fHxvcmFuZ2V8MTc3Nzg2OTIyNnww&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.blazes
  },
  {
    id: 'anim-04',
    title: 'Test Pattern Ballet',
    date: '2023-12-09',
    runtime: '01:45',
    description: 'A choreographed sequence built entirely around SMPTE bars and tone. Experimental piece for a gallery installation in Melbourne.',
    poster: 'https://images.unsplash.com/photo-1713871816577-d715fadefbec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxmaWxtJTIwZnJhbWV8ZW58MHx8fHwxNzc3ODY5MjQyfDA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.escapes
  }
];

export const GRAPHIC_WORKS = [
  {
    id: 'graf-01',
    type: 'image',
    title: 'Sunset Broadcast Poster',
    date: '2024-09-14',
    description: 'Risograph poster series for a local community radio station. Two-color print, hand-set type, warm pink and ochre inks.',
    src: 'https://images.unsplash.com/photo-1707332474972-d09ac7231426?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxyZXRybyUyMGRlc2lnbnxlbnwwfHx8b3JhbmdlfDE3Nzc4NjkyMzV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'graf-02',
    type: 'image',
    title: 'Autumn Zine Cover',
    date: '2024-05-02',
    description: 'Cover art for a quarterly independent zine. Collage of scanned textures, vintage magazine typography and hand drawn ornament.',
    src: 'https://images.unsplash.com/photo-1663630487197-8fc4cff14bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxyZXRybyUyMHBvc3RlcnxlbnwwfHx8b3JhbmdlfDE3Nzc4NjkyMjZ8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'graf-03',
    type: 'image',
    title: 'Type Specimen No. 07',
    date: '2024-02-18',
    description: 'A personal typographic exploration playing with condensed display faces and layered halftone plates.',
    src: 'https://images.unsplash.com/photo-1561226765-2f57ac3e915c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxyZXRybyUyMHR5cG9ncmFwaHl8ZW58MHx8fG9yYW5nZXwxNzc3ODY5MjI2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'graf-04',
    type: 'image',
    title: 'Workshop Identity System',
    date: '2023-11-27',
    description: 'Brand identity for a small ceramics workshop. Monogram, stationery and packaging, printed on recycled kraft stock.',
    src: 'https://images.pexels.com/photos/1601773/pexels-photo-1601773.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 'graf-05',
    type: 'video',
    title: 'Logo Build — Kiln & Co.',
    date: '2024-06-11',
    runtime: '00:22',
    description: 'Motion reveal for a rebrand pitch. Built in After Effects with subtle CRT wobble and scanline overlay.',
    poster: 'https://images.unsplash.com/photo-1663630487197-8fc4cff14bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxyZXRybyUyMHBvc3RlcnxlbnwwfHx8b3JhbmdlfDE3Nzc4NjkyMjZ8MA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.fun
  },
  {
    id: 'graf-06',
    type: 'video',
    title: 'Title Sequence Study',
    date: '2023-10-04',
    runtime: '00:36',
    description: 'Speculative opening titles for a fictional 1970s detective series. Kinetic typography driven by audio reactive waveforms.',
    poster: 'https://images.unsplash.com/photo-1561226765-2f57ac3e915c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxyZXRybyUyMHR5cG9ncmFwaHl8ZW58MHx8fG9yYW5nZXwxNzc3ODY5MjI2fDA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.joyrides
  }
];

export const MODEL_WORKS = [
  {
    id: 'model-01',
    title: 'Cathode Totem',
    date: '2024-10-01',
    software: 'Blender / Substance',
    description: 'Stylised tabletop shrine inspired by midcentury vacuum tube radios. Sculpted, retopologised and PBR textured.',
    primitive: 'torusKnot',
    color: '#f5a623'
  },
  {
    id: 'model-02',
    title: 'Antenna Bloom',
    date: '2024-07-15',
    software: 'ZBrush / Marmoset',
    description: 'Botanical-mechanical hybrid. A flower sprouting broadcast antennae. Hard surface sculpt with hand painted details.',
    primitive: 'icosahedron',
    color: '#cc5500'
  },
  {
    id: 'model-03',
    title: 'Broadcast Bot 04',
    date: '2024-04-20',
    software: 'Blender / Cycles',
    description: 'Low poly character built for real time rendering. Retro space-age proportions with CRT head module.',
    primitive: 'octahedron',
    color: '#ffb84d'
  },
  {
    id: 'model-04',
    title: 'Signal Obelisk',
    date: '2023-12-28',
    software: 'Houdini / Redshift',
    description: 'Procedural monument study. Displacement driven by archival radio frequency data.',
    primitive: 'dodecahedron',
    color: '#e07a1f'
  }
];

export const ART_WORKS = [
  {
    id: 'art-01',
    title: 'Orchard at Dusk',
    date: '2024-11-18',
    medium: 'Oil on linen, 60 x 80 cm',
    description: 'Plein air study completed over three evenings. Interested in how the last light of the day sits on warm earth tones.',
    src: 'https://images.unsplash.com/photo-1718644149171-0c82a0dd498c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwcGFpbnRpbmd8ZW58MHx8fG9yYW5nZXwxNzc3ODY5MjI2fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'art-02',
    title: 'Study of Hands',
    date: '2024-06-09',
    medium: 'Graphite and sanguine on toned paper',
    description: 'Sketchbook page from life drawing sessions. Exploring gesture and weight with limited tonal range.',
    src: 'https://images.unsplash.com/photo-1608804375269-d077e2a2adaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxkcmF3aW5nJTIwc2tldGNofGVufDB8fHx8MTc3Nzg2OTI0Mnww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'art-03',
    title: 'Quiet Room',
    date: '2024-02-04',
    medium: 'Watercolour and gouache, 30 x 40 cm',
    description: 'Interior study. Working from memory, trying to capture the particular stillness of an empty living room at midday.',
    src: 'https://images.pexels.com/photos/7171387/pexels-photo-7171387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 'art-04',
    title: 'Field Notes — Coast',
    date: '2023-09-21',
    medium: 'Ink and wash, sketchbook',
    description: 'A spread from a coastal sketching trip. Quick observations of wave rhythm and rock form, finished back in the studio.',
    src: 'https://images.pexels.com/photos/22690792/pexels-photo-22690792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  }
];

export const VFX_WORKS = [
  {
    id: 'vfx-01',
    type: 'video',
    title: 'Cosmic Signal Break',
    date: '2024-10-22',
    runtime: '00:28',
    description: 'Compositing test — CG particles integrated into live-action plate of a desert road at dusk. Nuke + Houdini Pyro.',
    poster: 'https://images.unsplash.com/photo-1713871816577-d715fadefbec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxmaWxtJTIwZnJhbWV8ZW58MHx8fHwxNzc3ODY5MjQyfDA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.escapes
  },
  {
    id: 'vfx-02',
    type: 'video',
    title: 'Analog Reentry',
    date: '2024-07-05',
    runtime: '00:50',
    description: 'Procedural smoke and atmospheric scattering across a greenscreen plate. Final grade pushed toward warm 70s stock.',
    poster: 'https://images.unsplash.com/photo-1618599919511-c0cd9e3625cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxmaWxtJTIwZnJhbWV8ZW58MHx8fHwxNzc3ODY5MjQyfDA&ixlib=rb-4.1.0&q=85',
    src: SAMPLE_VIDEOS.blazes
  },
  {
    id: 'vfx-03',
    type: 'image',
    title: 'Matte Painting — Tower',
    date: '2024-05-14',
    description: 'Digital matte painting built over photographic plates. Focus on practical lens characteristics and colour temperature.',
    src: 'https://images.unsplash.com/photo-1714972255728-7796cf11bb24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwYW5pbWF0aW9ufGVufDB8fHxvcmFuZ2V8MTc3Nzg2OTIyNnww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'vfx-04',
    type: 'image',
    title: 'Wire Removal Breakdown',
    date: '2024-01-31',
    description: 'Still from a complex clean-up shot. Tracking, paint, despill and final integration, presented as a layered breakdown.',
    src: 'https://images.unsplash.com/photo-1658580768843-510733773b12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwYW5pbWF0aW9ufGVufDB8fHxvcmFuZ2V8MTc3Nzg2OTIyNnww&ixlib=rb-4.1.0&q=85'
  }
];

export const PROFILE_IMAGE = 'https://images.unsplash.com/photo-1613353948535-0f50344f69f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTYxOTB8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBzdHVkaW98ZW58MHx8fG9yYW5nZXwxNzc3ODY5MjI2fDA&ixlib=rb-4.1.0&q=85';
